export default function SOutgoingCall({ size = 20, className = "", ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path d="M31 1V18.7866H25.0711V11.0791L5.1502 31L1 26.8498L20.921 6.92885H13.2134V1H31Z" fill="currentColor"/>
        </svg>
    )
}